import React, { useEffect } from 'react';
import './style.scss';

export const GenericTooltip = ({
  children,
  timeToHide,
  classNames = [''],
  styles = {},
  showTooltip = false,
  onCloseTooltip,
}) => {
  useEffect(
    () => {
      if (!timeToHide && !showTooltip) return;
      let tick;

      tick = setTimeout(() => {
        onCloseTooltip();
      }, timeToHide * 1000);

      return () => {
        clearTimeout(tick);
      };
    },
    [showTooltip],
  );

  if (!showTooltip) return null;

  return (
    <div
      className={['cv-generic-tooltip fade__in', ...classNames].join(' ')}
      style={styles}
    >
      {children}
      <div className="cv-generic-tooltip__arrow" />
    </div>
  );
};
